import React, { useState, useRef, useEffect } from 'react'
import Navbar from '../components/navbar'
import Sidemanu from '../components/sidemanu'
import { AutoComplete, Dropdown, message, Popconfirm } from 'antd'
import { AiFillDelete, AiOutlineClose, AiOutlineInteraction, AiOutlineMail } from 'react-icons/ai'
import { ImUpload2, ImUserTie } from 'react-icons/im'
import { DatePicker, Space } from "antd";
import { imageDb } from "../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import Cookies from 'js-cookie';
import Papa from 'papaparse';
import { GiFirstAidKit } from 'react-icons/gi'
import { FaRegUser } from 'react-icons/fa'
import { TbReportAnalytics, TbUserShare } from 'react-icons/tb'
import { MdOutlineUpdate, MdOutlineViewDay } from 'react-icons/md'
import { IoIosArrowDropdown } from 'react-icons/io'
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from 'axios';
import { useNavigate } from 'react-router-dom'
import NotLogin from './notLogin'
import { Checkbox, Drawer, Menu, Slider, Tag } from "antd";
import {
  Button,
  Input, Select
} from "antd";

function KitReport(params) {
  const [filterPracNames, setFilterPracNames] = useState([]);
  const [filterPrice, setFilterPrice] = useState([]);
  const [selectedPrac, setSelectedPrac] = useState([]); // State to manage selected values
  const [selectedPrice, setSelectedPrice] = useState([]); // State to manage selected values
  const [selectedStatus, setSelectedStatus] = useState([]); // State to manage selected values
  const [selectedKitType, setSelectedKitType] = useState([]); // State to manage selected values
  const [maxPrice, setMaxPrice] = useState([]); // State to manage selected values
  const [open, setOpen] = useState(false);
  const [filterDates, setFilterDates] = useState([null, null]);
  const [filterDates2, setFilterDates2] = useState([null, null]);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const handleDateChange = (value) => {
    setFilterDates(value); // value is an array with [startDate, endDate]
  };

  const handleDateChange2 = (value) => {
    setFilterDates2(value); // value is an array with [startDate, endDate]
  };



  const { RangePicker } = DatePicker;

  const handleClearPracName = () => {
    setSelectedPrac([]); // Clear selected values on delete icon click
  };
  const handleClearPrice = () => {
    // setSelectedPrice([]); // Clear selected values on delete icon click
    setFilterPrice([]); // Clear selected values on delete icon click
  };
  const handleClearStatus = () => {
    setSelectedStatus([]); // Clear selected values on delete icon click
  };
  const handleClearKittype = () => {
    setSelectedKitType([]); // Clear selected values on delete icon click
  };

  const tagRender = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        // color={value}
        color="#6e4e9f"
        // color= {(`#${Math.floor(Math.random() * 16777215).toString(16)}`)}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{
          // marginInlineEnd: 4,
          margin: "4px", // Space between tags
          padding: "4px 8px", // Inner padding inside each tag
          display: "flex",
          alignItems: "center",
        }}
      >
        {label}
      </Tag>
    );
  };

  const fileInputRef = useRef(null);

  const loginemail = Cookies.get("email")
  const loginname = Cookies.get("Name")
  const id = Cookies.get("id")
  const token = Cookies.get("Token")
  const [kitdetails, setkitdetails] = useState([])
  const [popupdetails, setpopupdetails] = useState(false)

  const [kit, setkit] = useState([])
  const [practitioner, setpractitioner] = useState([])



  const backgroundcolor = Cookies.get("backgroundcolor") || params.backgroundcolor;
  const color = Cookies.get("color") || params.color;
  const Buttonbackgroundcolor = Cookies.get("Buttonbackgroundcolor") || params.Buttonbackgroundcolor;
  const Buttoninsidecolor = Cookies.get("Buttoninsidecolor") || params.Buttoninsidecolor;
  const prinarycolor = Cookies.get("prinarycolor") || params.prinarycolor;
  const prinarycolortext = Cookies.get("prinarycolortext") || params.prinarycolortext;
  const seconderycolor = Cookies.get("seconderycolor") || params.seconderycolor;
  const portalid = Cookies.get("portalid") || params.portalid;


  const loginid = Cookies.get("id")

  const token2 = Cookies.get("Token2")
  const apiurlforbackend = process.env.REACT_APP_APIURL


  const navigate = useNavigate()

  const [kit2, setkit2] = useState([])

  const [kitids, setkitids] = useState([])
  const [page, setpage] = useState(1)
  const [page2, setpage2] = useState(1)

  const [totalPages, settotalPages] = useState(1)
  const [totalPages2, settotalPages2] = useState(1)
  const [totalkits, settotalkits] = useState(0)


  const [practitioner2, setpractitioner2] = useState([])


  const type = params.kittype



  var sno1 = 1 + (15 * (page - 1))

  const [searchTerm, setSearchTerm] = useState('');
  var options = kitids;

  const handleInputChange = async (e) => {
    e.preventDefault()

    setkit([])

    let tokentosend
    if (token2 === "afdksjfjsdgfjgsdugcsduygfcsdvcfgsdcfgtysdftd") {
      tokentosend = "dskgfsdgfkgsdfkjg35464154845674987dsf@53"
    } else {
      tokentosend = token
    }
    let data = JSON.stringify({

      "type": type,
      "search": searchTerm,
      "token": tokentosend,
      "loginid": loginid,
      "portalid": portalid
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: apiurlforbackend + '/searchkitsforresults',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    await axios.request(config)
      .then(async (response) => {
        await setkit(response.data.data)
        await setpractitioner(response.data.practitioners)
        await setpage(response.data.totalPages)
        await settotalPages(response.data.totalPages)
        await renderPageNumbers()

      })
      .catch((error) => {
        console.log(error);
      });

    setsearchdone(true)

  };

  useEffect(() => {
    if (token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53") {
      getpractoassign();
    }
  }, []);
  const getpractoassign = async () => {
    let data = JSON.stringify({

      portalid: portalid,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: apiurlforbackend + "/getpracinfotoassign",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    await axios
      .request(config)
      .then((response) => {
        // setFilterPracNames(response.data.map((user) => ({ value: user.name })));
        setFilterPracNames((prevData) => [
          ...prevData,
          ...response.data.map((user) => ({ value: user.email })),
        ]);
      })
      .catch((error) => {
        //console.log(error);
      });
  };



  const downloadascsv = async (kitss) => {
    const hide = message.loading("Downloading report...", 0);
    // let kitCodes = kit.map((item) => item.kitid);
    let kitCodes = kitss ? [kitdetails.kitid] : kit.map((item) => item.kitid);

    const data = {
      kitCodes,
      portalid,
      token,
      loginid,
      type,
    };
    kitCodes = kitss ? [kitss] : kitCodes

    try {
      const response = await axios.post(
        `${apiurlforbackend}/downloadcsv`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          responseType: 'blob', // 👈 this is important for file downloads
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

      link.setAttribute('download', `kits_report_${formattedDate}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      message.success("CSV Report has been downloaded successfully!");
    } catch (error) {
      console.error('Error downloading CSV:', error);
      message.error('Failed to download CSV');
    }
    finally {
      hide(); // Close loading message
    }
  };



  const [searchdone, setsearchdone] = useState(false)

  const clearsearch = async () => {


    await setkit(kit2)
    await setpractitioner(practitioner2)
    await setpage(page2)
    await settotalPages(totalPages2)
    await renderPageNumbers()

    setsearchdone(false)

  }







  const setkitbyres = async (response) => {

    setkit(response.data.data);
    setkit2(response.data.data);
    setpractitioner(response.data.practitioner);
    setpractitioner2(response.data.practitioner);
    setpage(response.data["current page"])
    setpage2(response.data["current page"])
    settotalPages(response.data["total pages"])
    settotalPages2(response.data["total pages"])
    settotalkits(response.data["total kits"])


  }






  const getkits = async (page) => {



    let tokentosend
    if (token2 === "afdksjfjsdgfjgsdugcsduygfcsdvcfgsdcfgtysdftd") {
      tokentosend = "dskgfsdgfkgsdfkjg35464154845674987dsf@53"
    } else {
      tokentosend = token
    }
    let data = JSON.stringify({
      "pagenumber": page,
      "type": type,
      "token": tokentosend,
      "loginid": loginid,
      "portalid": portalid,
     
      "selectedPrac": selectedPrac,

    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: apiurlforbackend + '/getkitsbytypeforresults',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    await axios.request(config)
      .then((response) => {
        setkitbyres(response)


      })
      .catch((error) => {
        console.log(error);
      });


  }



  const getkitsids = async () => {



    let tokentosend
    if (token2 === "afdksjfjsdgfjgsdugcsduygfcsdvcfgsdcfgtysdftd") {
      tokentosend = "dskgfsdgfkgsdfkjg35464154845674987dsf@53"
    } else {
      tokentosend = token
    }
    let data = JSON.stringify({

      "type": type,
      "token": tokentosend,
      "loginid": loginid,
      "portalid": portalid
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: apiurlforbackend + '/getallkitidsforreportpage',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    await axios.request(config)
      .then((response) => {
        setkitids(response.data.kitID);

      })
      .catch((error) => {
        console.log(error);
      });


  }




  useEffect(() => {
    getkits(page)
    getkitsids()

  }, [])




  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageToShow = 3; // Show maximum 3 pages on each side of the current page
    const startPage = Math.max(1, page - maxPageToShow);
    const endPage = Math.min(totalPages, page + maxPageToShow);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <span
          key={i}
          onClick={() => handlePageClick(i)}
          className={page === i ? 'activeeee' : ''}
        >
          {i}
        </span>
      );
    }
    return pageNumbers;
  };



  const handlePageClick = async (pageNumber) => {
    await setkit([])

    await window.scrollTo(0, 0);
    await getkits(pageNumber)

    await renderPageNumbers()
  };








  useEffect(() => {
    console.log("params " + params)
    console.log(params.kittype)
    console.log(kitdetails.kitid)
  }, [kitdetails])





  const items = [
    {
      key: '1',
      label: (
        <a href={`/report/${kitdetails._id}`} target="_blank" rel="noopener noreferrer">
          View result
        </a>
      ),
      icon: <MdOutlineViewDay style={{ width: '20px', height: '20px', color: '#4885B9' }} />,
    },
    ...(type === "FoodSensitivityMap") ? [(params.kittype === 'FoodSensitivityMap' && {
      key: '2',
      label: (
        <a onClick={() => downloadascsv(true)}>
          Download Result as CSV
        </a>
      ),
      icon: <MdOutlineViewDay style={{ width: '20px', height: '20px', color: '#4885B9' }} />,
    })] : [],

    ...(token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53"
      ? [
        {
          key: '3',
          label: (

            <Popconfirm
              title="Are you sure?"
              onConfirm={async (e) => {
                e.preventDefault();


                let data = JSON.stringify({
                  pagenumber: page,
                  type: type,
                  id: kitdetails._id,
                  emailtype: "results",
                  "portalid": portalid,
                });

                let config = {
                  method: "post",
                  maxBodyLength: Infinity,
                  url: apiurlforbackend + "/sendemailtoprac",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  data: data,
                };

                await axios
                  .request(config)
                  .then(() => {
                    getkits(page);
                    setpopupdetails(false);
                  })
                  .catch((error) => {
                    console.log(error);
                  });


              }}
            >
              <p
                href="#"
              // onClick=
              >
                Send Results To Practitioner
              </p>
            </Popconfirm>
          ),
          disabled: kitdetails.ackresult,
          icon: <AiOutlineMail style={{ width: '20px', height: '20px', color: '#4885B9' }} />,
        },
      ]
      : []),
  ];





  // const downloadascsv = async () => {

  // const kitCodes = kit.map((item) => item.kitid);

  // let data = JSON.stringify({
  //     kitCodes: kitCodes,
  //     portalid: portalid,
  //     token: token,
  //     loginid: loginid,
  //     type: type,
  // });

  // let config = {
  //     method: 'post',
  //     url: apiurlforbackend + '/downloadcsv',
  //     headers: {
  //         'Content-Type': 'application/json'
  //     },
  //     data: data
  // };

  // axios.request(config)
  //     .then((response) => {
  //         const url = window.URL.createObjectURL(new Blob([response.data]));
  //         const link = document.createElement('a');
  //         link.href = url;
  //         link.setAttribute('download', 'kits_report.csv');
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);
  //     })
  //     .catch((error) => {
  //         console.error('Error downloading CSV:', error);
  //         message.error('Failed to download CSV');
  //     });

  // }



  return (
    <>{(token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" || token === "sdrfg&78967daghf#wedhjgasj(dlsh6kjsdg") ? <>
      <div>

        <Navbar />

        <div className='deshboardmain' style={{ backgroundColor: backgroundcolor }}>

          <Sidemanu />
          <div className='adminkitmainbody'>



            <div className='header'>
              <h1 style={{ color: prinarycolor, display: 'flex', alignItems: 'center' }}><TbReportAnalytics style={{ width: '35px', height: '35px' }} />{type} Results </h1>
              {searchdone === false && <>
                <form onSubmit={handleInputChange}>


                  <AutoComplete

                    style={{ width: 200 }}
                    options={options}
                    placeholder="Search by Kit ID"
                    onChange={(inputValue) => setSearchTerm(inputValue)}
                    filterOption={(inputValue, options) =>
                      options.value.toString().toUpperCase().indexOf(inputValue.toUpperCase()) !== -1

                    }
                  />
                  <button style={{ backgroundColor: Buttonbackgroundcolor, color: Buttoninsidecolor }}>Search</button>
                </form>
              </>}
              {searchdone === true && <>     <div className='clearsearch'  ><h3>search: {searchTerm}</h3> <button onClick={clearsearch}><AiOutlineClose /> Clear</button>  </div>
              </>}
            </div>



            <div style={{ marginLeft: "20px", marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>

              <div className='header' style={{ marginBottom: '10px',display: 'flex', justifyContent:"end",gap:"10px" }}>
                {type === "FoodSensitivityMap" && <>

                  <Button onClick={() => downloadascsv(false)} style={{ backgroundColor: Buttonbackgroundcolor, color: Buttoninsidecolor }} className='button'>Download as CSV

                  </Button>
                </>}

                {token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" && <>
                  <Button style={{ backgroundColor: Buttonbackgroundcolor, color: Buttoninsidecolor }} type="primary" onClick={showDrawer}>
                    Filter
                  </Button>
                </>}
              </div>

              <Drawer
                title="Filter Kits"
                placement="right"
                onClose={onClose}
                open={open}
                closeIcon={
                  <CloseOutlined
                    style={{ color: "white", fontSize: "18px" }}
                  />
                }
                styles={{
                  header: {
                    backgroundColor: prinarycolor,
                    color: "white",
                  }, // Title background & color
                  body: { backgroundColor: "#f8f9fa" }, // Drawer body background
                }}
              >
                <div
                  className=""
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h2 style={{ color: prinarycolor }}>Practitioner</h2>
                  {/* <CloseOutlined  /> */}
                  <DeleteOutlined
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginRight: "5px",
                    }}
                    onClick={handleClearPracName}
                  />
                </div>

                <Select
                  mode="multiple"
                  tagRender={tagRender}
                  value={selectedPrac}
                  onChange={setSelectedPrac}
                  options={filterPracNames}
                  style={{
                    width: "100%",
                  }}
                />



          

                <div
                  className=""
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "40px",
                  }}
                >
                  <button
                    style={{
                      background: Buttonbackgroundcolor,
                      padding: "7px 90px",
                      borderRadius: "20px",
                      border: "none",
                      color: Buttoninsidecolor,
                      fontSize: "17px",
                    }}

                    onClick={async () => {
                      await onClose()
                      await setkit([])
                      await getkits(1)
                    }}
                  >
                    Filter
                  </button>
                </div>

                {/* <Select
                          mode="multiple"
                          tagRender={tagRender}
                          value={selectedPrice}
                          onChange={setSelectedPrice}
                          style={{
                            width: "100%",
                          }}
                          options={filterPrice}
                        /> */}
                {/* <Checkbox checked={checkedOne} onChange={onChangeOne}>
                          Practitioner Emails
                        </Checkbox>
                        <br />
                        <Checkbox checked={checkedTwo} onChange={onChangeTwo}>
                          Option Two
                        </Checkbox>
                        <br />
                        <Checkbox
                          checked={checkedThree}
                          onChange={onChangeThree}
                        >
                          Option Three
                        </Checkbox> */}
              </Drawer>
            </div>









            {popupdetails === true && <>
              <div onClick={() => {
                setpopupdetails(false)

              }
              } className='popupbg'></div>
              <div className='popup'>



                <div className='header' >
                  <h2 style={{ color: prinarycolor }}>Kits Result Details</h2>
                </div>
                <div className='kitdetailsmain' >




                  <div className='kitdetails'>
                    <h3 style={{ display: "flex", color: color, alignItems: 'center' }}> <GiFirstAidKit style={{ width: '20px', height: '20px', margin: "0 10px" }} /> KIT ID</h3><h3 style={{ display: "flex", color: prinarycolor, alignItems: 'center' }}>  {kitdetails.prefix}{kitdetails.kitid} </h3>
                  </div>
                  <div className='kitdetails'>
                    <h3 style={{ display: "flex", color: color, alignItems: 'center' }}> <FaRegUser style={{ width: '20px', height: '20px', margin: "0 10px" }} /> Practitioner Name</h3><h3 style={{ display: "flex", color: prinarycolor, alignItems: 'center' }}>


                      {practitioner.map((item2, index) => (<>

                        {item2._id === kitdetails.assignedto && <>

                          <td>{item2.name}</td>


                        </>}</>))}


                    </h3>
                  </div>
                  <div className='kitdetails'>

                    <h3 style={{ display: "flex", color: color, alignItems: 'center' }}> <TbUserShare style={{ width: '20px', height: '20px', margin: "0 10px" }} /> Practitioner Email</h3><h3 style={{ display: "flex", color: prinarycolor, alignItems: 'center' }}>


                      {practitioner.map((item2, index) => (<>

                        {item2._id === kitdetails.assignedto && <>



                          <td>{item2.email}</td>
                        </>}</>))}



                    </h3>
                  </div>

                  <div className='kitdetails'>
                    <h3 style={{ display: "flex", color: color, alignItems: 'center' }}> <ImUserTie style={{ width: '20px', height: '20px', margin: "0 10px" }} /> Patient Name</h3><h3 style={{ display: "flex", color: prinarycolor, alignItems: 'center' }}>  {kitdetails.patientName} </h3>
                  </div>
                  {/* <div className='kitdetails'>
                  <h3 style={{ display: "flex", color: color, alignItems: 'center' }}> <BsCalendar2DateFill style={{ width: '20px', height: '20px',margin:"0 10px" }} /> Date of birth</h3><h3 style={{ display: "flex", color: prinarycolor, alignItems: 'center' }}>  {kitdetails.DOB} </h3>
                </div> */}
                  {/* <div className='kitdetails'>
                  <h3 style={{ display: "flex", color: color, alignItems: 'center' }}> <MdOutlinePendingActions style={{ width: '20px', height: '20px',margin:"0 10px" }} /> Sample Date</h3><h3 style={{ display: "flex", color: prinarycolor, alignItems: 'center' }}>  {kitdetails.SampleDate} </h3>
                </div> */}
                  <div className='kitdetails'>
                    <h3 style={{ display: "flex", color: color, alignItems: 'center' }}> <MdOutlineUpdate style={{ width: '20px', height: '20px', margin: "0 10px" }} /> Result upload on</h3><h3 style={{ display: "flex", color: prinarycolor, alignItems: 'center' }}>  {kitdetails.resultDate} </h3>
                  </div>
                  <div className='kitdetails'><h3 style={{ display: "flex", color: color, alignItems: 'center' }}> <AiOutlineInteraction style={{ width: '20px', height: '20px', margin: "0 10px" }} /> Action</h3><h3 style={{ display: "flex", color: prinarycolor, alignItems: 'center' }}>


                    <Dropdown menu={{ items: items }} placement="bottomRight" arrow>
                      <IoIosArrowDropdown className='hovar' style={{ width: '20px', height: '20px', margin: "0 10px" }} />
                    </Dropdown>


                  </h3></div>





                </div>




                <div className='bownpopupbutton'>
                  <button onClick={() => {
                    setpopupdetails(false)

                  }
                  } style={{ border: '1px solid red', color: 'black' }} >cancel</button>












                </div>

              </div>
            </>}








            {kit.length !== 0 && <>




              <div className='header'><h3></h3><h3 style={{ color: prinarycolor }}>Total Kits: {totalkits}</h3></div>

              <table className='tablep' cellPadding={"10"} cellSpacing={"0"}>
                <thead className='tablephead' style={{ backgroundColor: prinarycolor, color: prinarycolortext }}>
                  <tr>
                    <th>S NO.</th>

                    <th>Kit ID</th>



                    {(token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" || token2 === "afdksjfjsdgfjgsdugcsduygfcsdvcfgsdcfgtysdftd") && <>      <th>Practitioner Name</th></>}
                    {(token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" || token2 === "afdksjfjsdgfjgsdugcsduygfcsdvcfgsdcfgtysdftd") && <>       <th>Practitioner Email</th></>}
                    {token === "sdrfg&78967daghf#wedhjgasj(dlsh6kjsdg" && <>     <th>Patient Name</th></>}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>


                  {kit.map((item, index) =>

                    <>
                      <tr >
                        <td style={{ color: prinarycolor }}>{sno1++} </td>

                        <td style={{ color: prinarycolor }}>{item.prefix}{item.kitid}</td>




                        {(token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" || token2 === "afdksjfjsdgfjgsdugcsduygfcsdvcfgsdcfgtysdftd") && <>

                          {practitioner.map((item2, index) => (<>

                            {item2._id === item.assignedto && <>
                              <td style={{ color: prinarycolor }}>{item2.name}</td>

                              <td style={{ color: prinarycolor }}>{item2.email}</td>
                            </>}</>))}

                        </>}
                        {token === "sdrfg&78967daghf#wedhjgasj(dlsh6kjsdg" && <>
                          <td style={{ color: prinarycolor }}>
                            {item.patientName}
                          </td>
                        </>}
                        <td  >
                          <button className='button' style={{ backgroundColor: Buttonbackgroundcolor, color: Buttoninsidecolor }} onClick={() => {
                            setpopupdetails(true)
                            setkitdetails(item)
                          }}>Detail</button>
                        </td>




                      </tr>
                    </>
                  )}



                </tbody>
              </table>




            </>}


            {kit.length === 0 && <>
              {totalPages === 0 ? (<>
                <img alt='' src='/empty2.gif' width={"35%"} />
              </>) : (<> <img alt='' src='/empty.gif' width={"40%"} /> </>)}
            </>}
            <div className="pagination">
              {page > 1 && (
                <span onClick={() => handlePageClick(page - 1)}>&lt;&lt;</span>
              )}
              {renderPageNumbers()}
              {page < totalPages && (
                <span onClick={() => handlePageClick(page + 1)}>&gt;&gt;</span>
              )}
            </div>






          </div>


        </div>

      </div>
    </> : <NotLogin />}</>
  )
}

export default KitReport